'use client';

import { useEffect } from 'react';

const AUXILIARY_FONT =
  'https://fonts.googleapis.com/css2?family=Source+Sans+3:wght@400;600&display=swap';

export function HeadOverride() {
  // The storefront uses self-hosted Jost. Keep the auxiliary CMS/widget font
  // available without adding a render-blocking Google CSS request to every URL.
  useEffect(() => {
    if (document.querySelector('link[data-ivato-auxiliary-font]')) return;
    const stylesheet = document.createElement('link');
    stylesheet.rel = 'stylesheet';
    stylesheet.href = AUXILIARY_FONT;
    stylesheet.dataset.ivatoAuxiliaryFont = 'true';
    document.head.appendChild(stylesheet);
  }, []);
  return (
    <noscript>
      <link href={AUXILIARY_FONT} rel="stylesheet" />
    </noscript>
  );
}
